<template>
<div>edit</div>
</template>

<script>
export default {
  name: 'PersonEditPersonalReservation',
}
</script>

<style scoped>

</style>
